// extracted by mini-css-extract-plugin
export default {"button":"Button_button__ZFnS2","secondary":"Button_secondary__hzEDU","pill":"Button_pill__JeUcW","disabled":"Button_disabled__mFJUk"};